import React from 'react'
import logo from '../../Images/ZinnovLogo.png'
import './Elem5Logo.css'

function Logo() {
  return (
  <div class="zinnovlogo">
    <div class="zinnovlogo-wrapper">
      <a href="https://dev.zinnov.com" className="logo">
        <img className='logo' src={logo} alt='ZinnovLogo' />
      </a>
    </div>
  </div>
  )
}

export default Logo
